<template>
  <van-overlay :show="!!type">
    <div class="wrap">
      <div class="block">
        <img
          src="@/assets/groupRob/close.png"
          alt=""
          class="close"
          @click="close"
        />
        <img src="@/assets/groupRob/modal-bg.png" alt="" class="icon" />
        <div class="title">{{ content }}</div>
        <div class="btn" @click="close">确定</div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  model: {
    prop: "type",
    event: "visibleChange",
  },
  props: {
    type: {
      type: String,
    },
  },
  data() {
    return {
      content: "",
    };
  },
  watch: {
    type(e) {
      switch (e) {
        case "success":
          this.content = "恭喜您，抢到该商品";
          break;
        case "fail":
          this.content = "很遗憾，您未抢到该商品";
          break;
        default:
          this.close();
          break;
      }
    },
  },
  methods: {
    close() {
      // this.$emit("visibleChange", null);
      this.$emit("close");
    },
    // confirm() {
    //   this.$emit("confirm");
    // },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  display: flex;
  justify-content: center;
  padding-top: 18rem;

  .block {
    width: 27.4rem;
    background: #fff;
    border-radius: 1rem;
    position: relative;
    font-size: 1.6rem;

    .close {
      position: absolute;
      top: -4.6rem;
      right: 0;
      width: 2.4rem;
      height: 2.4rem;
    }

    .icon {
      width: 100%;
    }

    .title {
      color: #333;
      text-align: center;
      padding: 0.9rem 1.2rem 2.2rem;
      font-weight: 700;
    }

    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #f9591b;
      position: relative;
      padding: 1.5rem;

      &::before {
        content: " ";
        display: block;
        width: calc(100% - 2 * 1.2rem);
        height: 0.1rem;
        background: #eee;
        position: absolute;
        top: 0;
        left: 1.2rem;
      }
    }
  }
}
</style>
